import React from "react";
import DepartmentsandTeams from "../components/DepartmentsTeams";

const DepartmentsTeams = () => {
  return (
    <>
      <DepartmentsandTeams />
    </>
  );
};

export default DepartmentsTeams;
